export default {
  header: {
    reserve: 'Reserve your place(s)',
    finalize: 'Finalize your booking'
  },
  home: {
    legend: {
      available: 'Available',
      reserved: 'Reserved',
      booked: 'Booked'
    },
    summary: {
      selected: '{count} place selected | {count} places selected',
      total: 'Total price: {price}€',
      clear: '✖ Clear selection',
      continue: 'Continue →'
    },
    error: {
      title: 'Looks like someone got there faster!',
      message: 'The place you chose was reserved. Have a look at other available options.',
      button: 'SELECT NEW PLACE'
    }
  },
  booking: {
    heading: 'Booking information',
    back: 'Back',
    fields: {
      country: 'Country',
      firstName: 'First name',
      lastName: 'Last name',
      phone: 'Phone number',
      email: 'E-mail',
      company: 'Company name',
      registration: 'Registration number',
      description: 'Product description',
      comments: 'Additional comments',
      commentsOptional: '(optional)',
      vatNumber: 'VAT Number'
    },
    countries: {
      latvia: 'Latvia',
      lithuania: 'Lithuania',
      estonia: 'Estonia',
      other: 'Other'
    },
    errors: {
      country: 'Please select your country',
      firstName: 'Please enter your name',
      lastName: 'Please enter your last name',
      phone: 'Please enter your phone no.',
      email: 'Please enter a valid email address',
      company: 'Please enter your company name',
      registration: 'Please enter your registration no.',
      description: 'Please describe your product',
      terms: 'Please agree to the terms',
      vatNumber: 'Please enter your VAT number'
    },
    inboxError: '{domain} emails are not accepted due to delivery issues. Please use another address.',
    termsLink: 'TERMS AND CONDITIONS',
    termsText: 'I have read the {link}, and agree to them.',
    vat: {
      text: 'My company is a registered VAT payer and holds a valid VAT number issued in Lithuania, Estonia, or another European Union country (<u>!NOT Latvia!</u>). The transaction should therefore be subject to the reverse-charge mechanism (0% VAT).',
      hint: 'e.g. EE123456789; LT12345679; LT123456789012',
      footnote: '*VAT Directive 2006/112/EC Art.44, Art.196<br> Subject to taxes (VAT) in the receiver\'s country.<br> Reverse charge'
    },
    vatLabel: 'VAT',
    total: 'TOTAL:',
    confirm: 'Confirm my booking'
  },
  tooltip: {
    status: {
      available: 'Available',
      reserved: 'Reserved',
      booked: 'Booked'
    },
    dimensions: 'Dimensions: 3x2 m',
    select: 'SELECT PLACE',
    deselect: 'DESELECT'
  },
  map: {
    foodCourt: 'FOOD COURT & PARTNERS PROMO ZONE',
    kidsWorkshops: 'KIDS WORKSHOPS',
    entrance: 'ENTRANCE',
    gate: 'GATE #{n}',
    foodSellers: 'FOOD SELLERS',
    kidsInflatables: 'KIDS INFLATABLES CITY &',
    partnersPromoZone: 'PARTNERS PROMO ZONE'
  },
  thankyou: {
    heading: 'Thank you!',
    line1: 'Your registration for the place(s) has been received.',
    line2: 'Soon you will receive an invoice and further information in your email!',
    returnHome: 'Return home',
    processing: 'Please wait, your invoice is being generated…',
    processingStep1: 'Generating invoice…',
    processingStep2: 'Sending confirmation email…',
    processingNote: 'Please do not close this page.',
    registrationStartsIn: 'Registration starts in',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds'
  }
}
